






import Vue from 'vue';
import UserProfile from './profile/UserProfile.vue';
import Accounts from '@/helpers/accountsIframe';

export default Vue.extend({
  components: {
    UserProfile,
  },
  props: {
    handleSignOut: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      logoLink: '/',
    };
  },
  computed: {
    email(): string | undefined {
      return Accounts.getEmailByPocket();
    },
    name(): string | undefined {
      return Accounts.getProfileName();
    },
  },
});
